module.exports = __webpack_public_path__ + "static/img/3.2f1f221.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/3/eng/3.png
// module id = 682G
// module chunks = 0